import React, { useState } from 'react';
import { string, bool } from 'prop-types';
import { Switch, styled } from '@nextiva/next-ui-components';
import { useSelector, useDispatch } from 'react-redux';

import { setIsVoiceMailActive } from 'containers/VoiceMail/reducers/options';
import { HuntGroupVoicemailService } from 'services';
import sassVars from 'styles/application/_base/_variables.scss';
import { pxToRem } from 'utils/pxToRemConverter';

const { putHuntGroupVoicemailStatus } = HuntGroupVoicemailService;

const animation =
  'left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;';

const SwitchStyled = styled(Switch)`
  display: flex;
  padding: 0;
  width: 56px;
  height: 30px;
  .MuiSwitch-switchBase {
    padding: 3px;
    color: ${sassVars.white};
    &.Mui-checked {
      color: ${sassVars.white};
      & + .MuiSwitch-track {
        position: absolute;
        opacity: 1;
        background-color: ${sassVars.primaryBlue};
        border-color: ${sassVars.primaryBlue};
      }
    }
    &:after {
      content: 'Off';
      display: ${({ display }) => !display};
      padding: 2px 0 0 3px;
      font-size: ${pxToRem('14px')};
      font-weight: 400;
    }
  }
  .Mui-checked {
    &:before {
      content: 'On';
      display: ${({ display }) => display};
      padding: 2px 6px 0 9px;
      font-size: ${pxToRem('14px')};
      font-weight: 400;
    }
  }
  .MuiSwitch-switchBase.Mui-checked {
    transform: translateX(
      ${({ display }) => (display === 'block' ? '0' : '26px')}
    );
    transition: ${({ display }) => (display === 'block' ? 'none' : animation)};
  }
  .MuiButtonBase-root:hover {
    background-color: transparent;
  }
  .MuiIconButton-label {
    .MuiSwitch-thumb {
      width: 24px;
      height: 24px;
      box-shadow: none;
    }
  }
  .MuiSwitch-track {
    position: absolute;
    background-color: ${sassVars.switchDisabled};
    border: 1px solid ${sassVars.switchDisabled};
    border-radius: 15px;
    opacity: 1;
  }
`;

const SwitchWrapper = ({ huntGroupId, checked, setUpdated }) => {
  const dispatch = useDispatch();
  const isVoiceMailActive = useSelector(
    (state) => state.options.isVoiceMailActive,
  );
  const [display, setDisplay] = useState('block');

  const onClick = () => {
    setDisplay(isVoiceMailActive ? 'none' : 'block');
    dispatch(setIsVoiceMailActive(!isVoiceMailActive));
    putHuntGroupVoicemailStatus(huntGroupId, {
      isVoiceMailActive: !isVoiceMailActive,
    })
      .then(() => {
        setUpdated(true);
      })
      .catch(() => {
        // TODO: failure message
      });
  };

  return (
    <SwitchStyled
      display={display}
      onClick={onClick}
      disableRipple
      checked={checked}
      data-testid="PlatformAdminUI-TeamVoiceSettings-VoicemailSwitch-Switcher"
    />
  );
};

SwitchWrapper.propTypes = {
  checked: bool.isRequired,
  huntGroupId: string.isRequired,
};

export default SwitchWrapper;
